export default __webpack_public_path__ + "static/media/person.cbf8b58c.svg";